const STORAGE_PREFIX = 'selectedEnterpriseId';

export function selectedEnterpriseStorageKey(userId: string): string {
  return `${STORAGE_PREFIX}.${userId}`;
}

export function readStoredEnterpriseId(userId: string | undefined): string | null {
  if (!userId || typeof localStorage === 'undefined') {
    return null;
  }
  return localStorage.getItem(selectedEnterpriseStorageKey(userId));
}

export function writeStoredEnterpriseId(userId: string | undefined, enterpriseId: string): void {
  if (!userId || typeof localStorage === 'undefined') {
    return;
  }
  localStorage.setItem(selectedEnterpriseStorageKey(userId), enterpriseId);
}

export function clearStoredEnterpriseId(userId: string | undefined): void {
  if (!userId || typeof localStorage === 'undefined') {
    return;
  }
  localStorage.removeItem(selectedEnterpriseStorageKey(userId));
}

export function resolveSelectedEnterprise<T extends { id: string }>(
  enterprises: T[],
  preferredId: string | null | undefined,
): T | null {
  if (!enterprises.length) {
    return null;
  }
  if (preferredId) {
    const match = enterprises.find((enterprise) => enterprise.id === preferredId);
    if (match) {
      return match;
    }
  }
  return enterprises[0];
}
